/* eslint @typescript-eslint/no-var-requires: "off" */
import 'open-sankey/src/css/bootstrap.css'
import 'open-sankey/src/css/main.css'
import './css/LicenseCheckIn.css'
import './css/Login.css'
import React from 'react'
import { render } from 'react-dom'

import SankeyApp from './SankeyApp'
import { convert_data,complete_sankey_data } from 'open-sankey/dist/SankeyConvert'
import { default_sankey_data,default_node,default_link } from 'open-sankey/dist/SankeyUtils'
import LZString from 'lz-string'
import './traduction'
import { useNavigate } from 'react-router-dom'
import { SuiteSankeyData, SuiteSankeyNode, SuiteSankeyLink } from './types'
import {app_name_opensankeyplus, app_name_sankeysuite} from './components/LicenseCheckIn/LicenseFunctions'

// Accounts token
let token=false
let has_sankey_suite=false
let has_open_sankey_plus=false
let has_sankeydev=false

declare const window: Window &
  typeof globalThis & {
    SankeyToolsStatic: boolean
    sankey: {
      filiere?: string,
      header?: string,
      has_header?: boolean,
      footer?: boolean,
      logo_width?: number,
      excel?: string,
      publish?: boolean
      logo?: string
    }
  }

let logo = ''
if(!window.SankeyToolsStatic){
  try {
    logo = require('./css/opensankey.png')
    const path = window.location.href
    if ( !path.includes('localhost')) {
      logo = logo.replace('static/', 'static/sankeysuite/')
    }
  } catch (expt) {
    console.log('opensankey.png not found')
  }
    
}


let logo_terriflux = ''
try {
  logo_terriflux = require('./css/terriflux.png')
  const path = window.location.href
  if ( !path.includes('localhost') ) {
    logo_terriflux = logo_terriflux.replace('static/', 'static/sankeysuite/')
  }
} catch (expt) {
  console.log('terriflux.png not found')
}



let suite_default_sankey_data : () => SuiteSankeyData = default_sankey_data

suite_default_sankey_data = () => {
  let type_to_return={...default_sankey_data()}
  if(has_sankey_suite){
    type_to_return={
    ...type_to_return,
    show_uncert: false,

    trade_sectors : [],
    trade_close_hspace: 50,
    trade_close_vspace: 20,
    trade_hspace: 200,

    trade_left_shift: 0.45,
    trade_right_shift: 0.55,
    trade_max_shift: 0.2,

    units_names : [[]],
    tooltip_names : []
    }
  }

  type_to_return={
    ...type_to_return,
    view:[],
    current_view:'none',
    labels:{},
    icon_catalog:{},
  }


  return type_to_return
}


window.SankeyToolsStatic = window.SankeyToolsStatic === undefined ? false : window.SankeyToolsStatic
if (!window.SankeyToolsStatic) {
  if (!window.sankey) {
    window.sankey = {}
  }





  const start_web_app=(
    token:boolean,
    set_token:(t:boolean)=>void,
    has_sankey_suite:boolean,
    set_sankey_suite:(t:boolean)=>void,
    has_open_sankey_plus:boolean,
    set_open_sankey_plus:(t:boolean)=>void,
    unsetTokens:()=>void
  )=>{
    window.React = React
   

    const data = suite_default_sankey_data()
    const json_data = LZString.decompress(localStorage.getItem('data') as string) as string
    if (json_data !== null && json_data !== 'undefined' && json_data !== '') {
      const new_data = JSON.parse(json_data)
      Object.assign(data, new_data)
      convert_data(data)
      data.static_sankey = window.SankeyToolsStatic ? window.SankeyToolsStatic : false
    }
    
    data.static_sankey = window.SankeyToolsStatic ? window.SankeyToolsStatic : false

    const fetchData = {
      method: 'POST'
    }

    let exemple_menu = {}
    let formations_menu = {}
    const path = window.location.origin
    const url = path + '/opensankey/sankey/menu_examples'
    fetch(url, fetchData).then(response => {
      response.text().then(text => {
        const json_data = JSON.parse(text)
        exemple_menu = json_data.exemples_menu
        formations_menu = {...json_data.exemples_menu['Formations']}
        if(!has_open_sankey_plus && formations_menu.hasOwnProperty('1_OpenSankeyAvancée')){
          formations_menu=Object.fromEntries(Object.entries(formations_menu).filter(d=>d[0]!=='1_OpenSankeyAvancée'))
        }
        if(!has_sankey_suite){
          formations_menu=Object.fromEntries(Object.entries(formations_menu).filter(d=>!['2_Structure','3_Arborescence_Hierarchies','4_Données_Contraintes_Reconciliation','5_Fiabilités','7_Scenarisation','8_Scenarisation_Gisements','9_Forêt_Bois','10_FluxDePorc','FichiersRéférences'].includes(d[0])))
        }
        delete json_data.exemples_menu['Formations']
          render(
            <>
              <SankeyApp
                initial_sankey_data={data}
                exemple_menu={exemple_menu}
                formations_menu={formations_menu}
                logo={logo}
                logo_terriflux={logo_terriflux}
                token={token}
                set_token={set_token}
                has_sankey_suite={has_sankey_suite}
                set_sankey_suite={set_sankey_suite}
                has_open_sankey_plus={has_open_sankey_plus}
                set_open_sankey_plus={set_open_sankey_plus}
                has_sankeydev={has_sankeydev}
                set_sankeydev={set_sankeydev}
                unsetTokens={unsetTokens}
                useNavigate={useNavigate}
                get_default_data={suite_default_sankey_data}
              />
            </>,
            document.getElementById('react-container')
          )
      }).catch(() => {
        render(
          <>
            <SankeyApp
              initial_sankey_data={data}
              exemple_menu={{}}
              formations_menu={{}}
              logo={logo}
              logo_terriflux={logo_terriflux}
              token={token}
              set_token={set_token}
              has_sankey_suite={has_sankey_suite}
              set_sankey_suite={set_sankey_suite}
              has_open_sankey_plus={has_open_sankey_plus}
              set_open_sankey_plus={set_open_sankey_plus}
              has_sankeydev={has_sankeydev}
              set_sankeydev={set_sankeydev}
              unsetTokens={unsetTokens}
              useNavigate={useNavigate}
              get_default_data={suite_default_sankey_data}
            />
          </>,
          document.getElementById('react-container')
        )
      })
    })
  }

  // Login token
  const set_token=(t:boolean)=>{
    token=t
    renderPage()
  }

  // AFM Sankey token
  const set_sankey_suite=(t:boolean)=>{
    has_open_sankey_plus=t
    has_sankey_suite=t
    renderPage()
  }

  // OpenSankey+ token
  const set_open_sankey_plus=(t:boolean)=>{
    has_open_sankey_plus=t
    renderPage()
  }

  // SankeyDev token
  const set_sankeydev=(t:boolean)=>{
    has_sankeydev=t
    renderPage()
  }

  // LogOut
  const unsetTokens=()=>{
    token=false
    has_sankey_suite=false
    has_open_sankey_plus=false
    has_sankeydev=false
    renderPage()
  }




  const renderPage=()=>{
    start_web_app(
      token, set_token,
      has_sankey_suite, set_sankey_suite,
      has_open_sankey_plus, set_open_sankey_plus,
      unsetTokens)
  }

  const storage_token=LZString.decompress(sessionStorage.getItem('token') as string) as string
  if(storage_token!==null && storage_token!==''){
    const d_t=JSON.parse(storage_token)
    set_token(d_t)
  }

  const storage_token_plus=LZString.decompress(sessionStorage.getItem(app_name_opensankeyplus) as string) as string
  if(storage_token_plus!==null && storage_token_plus!==''){
    const d_t=JSON.parse(storage_token_plus)
    set_open_sankey_plus(d_t)
  }

  const storage_token_suite=LZString.decompress(sessionStorage.getItem(app_name_sankeysuite) as string) as string
  if(storage_token_suite!==null && storage_token_suite!==''){
    const d_t=JSON.parse(storage_token_suite)
    set_sankey_suite(d_t)
  }

  const storage_token_dev=LZString.decompress(sessionStorage.getItem('SankeyDev') as string) as string
  if(storage_token_dev!==null && storage_token_dev!==''){
    const d_t=JSON.parse(storage_token_dev)
    set_sankeydev(d_t)
  }

  renderPage()

} else {
  window.React = React

  const data = suite_default_sankey_data()
  if (window.sankey.filiere) {
    localStorage.setItem('data', LZString.compress(JSON.stringify(window.sankey.filiere)))
  }

  const json_data = LZString.decompress(localStorage.getItem('data') as string) as string
  if (json_data !== null && json_data !== 'undefined' && json_data !== '') {
    const new_data = JSON.parse(json_data)
    Object.assign(data, new_data)
    convert_data(data)
    data.static_sankey = window.SankeyToolsStatic ? window.SankeyToolsStatic : false
  }


    render(
      <>
      <SankeyApp
        initial_sankey_data={data}
        exemple_menu={{}}
        formations_menu={{}}
        logo={logo}
        logo_terriflux={'logo_terriflux.png'}
        token={token}
        set_token={()=>null}
        has_sankey_suite={true}
        set_sankey_suite={()=>null}
        has_open_sankey_plus={true}
        set_open_sankey_plus={()=>null}
        has_sankeydev={true}
        set_sankeydev={()=>null}
        unsetTokens={()=>null}
        useNavigate={()=>''}
        get_default_data={suite_default_sankey_data}
      />
    </>,
    document.getElementById('react-container')
  )
}
